/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Optional_It_SkillsInputs */

const de_optional_it_skills = /** @type {(inputs: Optional_It_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IT-Kenntnisse (förderlich)`)
};

/** @type {(inputs: Optional_It_SkillsInputs) => LocalizedString} */
const en_optional_it_skills = () => /** @type {LocalizedString} */ ('optional_it_skills')

/**

* @param {Optional_It_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const optional_it_skills = /** @type {((inputs?: Optional_It_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Optional_It_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_optional_it_skills(inputs)
	return en_optional_it_skills(inputs)
});